<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <path
            class="fil0 str1"
            d="M71 52l-40 0c0,1 0,22 0,23 0,1 1,1 1,2 0,1 0,2 0,3 0,1 0,3 0,4 0,1 0,2 0,3 0,1 -1,1 -2,2 0,0 -2,2 -2,3 0,1 3,3 3,4 0,0 0,1 1,2 0,1 0,2 0,3 0,1 0,2 -1,2 -1,1 -4,3 -3,5 0,1 2,2 3,3 0,0 0,1 0,1 0,0 0,1 0,2 0,0 0,1 0,1 0,1 0,1 0,2 0,1 0,1 0,1 -1,2 -4,2 -3,5 0,1 3,3 4,5 0,1 0,3 0,4 0,2 -4,3 -4,5 0,4 4,4 4,9 0,4 -3,4 -3,7 0,3 8,15 11,18l17 0c2,-1 5,-3 7,-5 3,-3 4,-8 4,-12 0,-4 4,-5 4,-8 0,-2 -4,-3 -4,-7 0,-6 4,-6 4,-9 0,-2 -4,-3 -4,-5 0,-1 0,-3 0,-4 0,-2 4,-4 4,-5 0,-3 -3,-3 -3,-5 0,-1 0,-6 0,-7 1,-1 3,-2 3,-3 0,-2 -2,-3 -3,-5 -1,-1 -1,-5 0,-6 1,-1 3,-3 3,-4 0,-1 -4,-4 -4,-5 0,-1 3,-2 3,-3 0,-1 0,-22 0,-23zm-41 102c11,-1 27,-3 39,-7m-39 -8c11,-1 26,-3 38,-6m-38 -8c10,-1 25,-3 38,-6m-37 -8c11,-1 25,-3 37,-6m-38 43c11,-1 26,-3 39,-7m-39 -8c11,-1 27,-3 39,-7m-39 -8c12,-1 27,-3 38,-7m-39 -8c13,-1 27,-3 39,-7m-39 0c11,-1 25,-3 38,-6m-38 -1c11,-1 26,-3 38,-7"
        />
        <path
            class="filWhite str1"
            d="M48 16c18,0 33,13 31,30 -1,5 -3,9 -7,17 -1,2 -3,5 -4,7 -4,5 -10,9 -18,10 -11,2 -18,-4 -23,-12 -5,-8 -7,-19 -8,-26 -1,-14 11,-26 29,-25z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
